// Must stay the first import: adds the sign-in token to fetch before other modules copy it.
import './utils/authToken';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import App from './App';
import { installErrorLogging } from './utils/errorLog';

// Local `npm start` stays quiet; every deployed build (dev/staging/prod) reports.
if (process.env.NODE_ENV === 'production') installErrorLogging();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
